<template>
    <div class="quote-slider">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <cmp-carousel facet="quotes" :items="content.quotes" :show-arrows="false">
            <template slot="item" slot-scope="props">
                <div class="quote-slider--item">
                    <blockquote class="quote-slider--quote">
                        <span v-text="props.item.quote"></span>
                    </blockquote>
                    <span class="quote-slider--author" v-text="props.item.author"></span>
                </div>
            </template>
        </cmp-carousel>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?7c3b0677